/**
 * ListItem.js
 *
 * Analogous to Widget, which produces form input elements, ListItem creates
 * generic elements for lists (matching input item types).
 *
 * Copyright (c) apploft. GmbH
 */
import { PushNotification } from './PushNotification';
import ScheduledPushNotification from './ScheduledPushNotification';
var push = Symbol('push notification');
var scheduledPush = Symbol('scheduled push notification');
var none = Symbol('unkown item');

function isImmediatePush(_ref) {
  var pushProviderResult = _ref.pushProviderResult;
  return !!pushProviderResult;
}

function isSchedulePush(_ref2) {
  var schedule = _ref2.schedule;
  return !!schedule;
}

function ascertainItemType(item) {
  if (isImmediatePush(item)) {
    return push;
  }

  if (isSchedulePush(item)) {
    return scheduledPush;
  }

  return none;
}

function ListItem(_ref3) {
  var item = _ref3.item,
      onClick = _ref3.onClick;
  var itemType = ascertainItemType(item);

  switch (itemType) {
    case push:
      return PushNotification(item);

    case scheduledPush:
      return ScheduledPushNotification(item, onClick);

    default:
      throw new Error("unknown item type: ".concat(itemType.toString()));
  }
}

export default ListItem;